module.exports = __webpack_public_path__ + "5c114213/img/boston-lights.a623432f.png";